import animateProperty from '../utils/animate-property'
import animateFunction from '../utils/animate-function'

class ScrollNav {
	constructor(el) {
		this.el = el

		this.bodyRef = document.querySelectorAll('body')[0]
		this.htmlRef = document.querySelectorAll('html')[0]
		this.interchangingLogos = document.querySelectorAll('[data-role="js--interchanging-logos"]')[0];

		jQuery(window).on('activate.bs.scrollspy', function (e,obj) {
			// console.log(e,obj)
			if (obj) {
				let item = jQuery("[href='"+obj.relatedTarget+"']");
				// console.log("item",item)

				if ( !item || item.length == 0 ) return false;

				let iBCR = item[0].getBoundingClientRect();

				let iL = iBCR.left;
				let iR = iBCR.right;
				let snSL = this.el.scrollLeft;
				let wW = window.innerWidth - 30;

				// console.log("item right edge",iR,"item left edge",iL)
				// console.log("window right edge",wW)
				// console.log("scrollLeft",snSL)

				if ( iR > wW ) {
					// console.log("item hidden right")
					animateProperty(this.el, 'scrollLeft', (iL - 15), () => {}, 100);
					// this.el.scrollLeft = iL - 15;
				}
				else if ( iL < 0 ) {
					// console.log("item hidden left")
					animateProperty(this.el, 'scrollLeft', (iR - 15), () => {}, 100);
					// this.el.scrollLeft = iR - 15;
				}
			}
		}.bind(this));

		if ( this.interchangingLogos ) {
			jQuery(window).scroll(function() {
				this.interchangingLogos.classList.toggle('is-reversed', this.htmlRef.scrollTop > 600 );
			}.bind(this));
		}
	}
}

export default ScrollNav
